
import { PuffLoader } from 'react-spinners';
import './LoadingBlock.css';
import { Icons } from '../Icons/Icons';
import { useEffect } from 'react';
import { appInsights } from '../../../../Services/AppInsightsService';

export const LoadingBlock = ({ showLogo }: { showLogo?: boolean }) => {



    //
    // If the loading block is shown for more than 10 seconds, 
    // we will log out the user
    //
    useEffect(() => {
        appInsights.startTrackEvent('LoadingBlock');

        // var timeout: NodeJS.Timeout;
        // const heartBeat = () => {
        //     appInsights.trackEvent({ name: 'LoadingBlock | Heartbeat' });
        //     timeout = setTimeout(heartBeat, 5000); // every 5 seconds, do it again
        // }
        
        // heartBeat();

        return () => {

            appInsights.stopTrackEvent('LoadingBlock');
            // clearTimeout(timeout);
        }

    }, []);

    return (
        <div className="LoadingBlock flex-grow">

            {showLogo && <div className='flex flex-row align-items-center justify-content-center w-full'>
                <Icons.Logo />
            </div>}
            <PuffLoader
                className='PuffLoader'
                color="#6f5b30"
                speedMultiplier={.5}
                size={60}
            />
            <div className="flex flex-row align-items-center">
                <p className='gl-header-subtitle-typography'> Loading...</p>
            </div>

        </div>
    );
};